(function() {
    'use strict';
    angular
        .module('dialysisApp')
        .factory('Modality', Modality);

    Modality.$inject = ['$resource'];

    function Modality ($resource) {
        var resourceUrl =  'api/modalities/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
